import React from 'react';

import Title from '../../components/Title';
import Spreader from '../../components/Spreader';
import Paragraph from '../../components/Paragraph';
import Quote from '../../components/Quote';

import QuoteNoPhoto from '../../components/QuoteNoPhoto';
import Sticker from '../../components/Sticker';
import Menu from '../../components/Menu';
import Grid from '../../components/Grid';
import Banner from '../../components/Banner';
import Mention from '../../components/Mention';
import Scalable from '../../components/Scalable';
import CallToAction from '../../components/CallToAction';

import { StickyContainer } from 'react-sticky';

const PlacePage = props => (
  <StickyContainer>
    <Menu active="place" />
    <Spreader>
      <Title text="Проект красит место" />
      <Paragraph>
        Основное потребительское качество недвижимости, отличающее ее от
        остальных товаров – невозможность перемещения объекта в пространстве.
        Можно изменить проектное решение, цвет фасада и даже вид разрешенного
        использования, но изменить местоположение и перенести дом, скажем, на
        «Золотую милю» ну никак не получится. Зато хороший девелоперский проект
        вполне может создать свою, если не «золотую», то хотя бы «бронзовую»
        милю в другом районе города, поднять его статус на несколько ступеней
        вверх, улучшить городскую среду, изменить отношение местных жителей к
        своему району, добавить престижа и – постепенно изменить и состав
        населения.
      </Paragraph>
    </Spreader>

    <Spreader>
      Процесс хоть и долгий, но вполне реальный и вовсе не редкий, начать его
      вполне может один отдельно взятый объект. В Москве самым ярким примером
      того, как несколько новых домов высокого класса сумели запустить процесс
      трансформации городской среды и отношения города к месту, может считаться
      все та же «Золотая миля». Сегодня мало кто помнит, что всего-то двадцать
      лет назад этот район города был вовсе элитным, а скорее даже маргинальным.
      Но появились первые статусные проекты, постепенно под их уровень
      «подтянулись» старые дома, сменился состав жителей.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Такая метаморфоза происходит сегодня и&nbsp;в&nbsp;других районах Москвы,
      где появляются проекты более высокого класса по&nbsp;сравнению
      с&nbsp;качеством существующего жилого фонда. Для примера можно привести
      два проекта компании &laquo;Галс-Девелопмент&raquo;&nbsp;&mdash;
      &laquo;Наследие&raquo; в&nbsp;Преображенском районе и&nbsp;Match Point
      на&nbsp;ул.&nbsp;Василисы Кожиной.
    </Spreader>

    <Spreader style={{ marginBottom: '10px' }}>
      Оба района занимают высокие строки в городском рейтинге и достаточно
      престижны. Но оба обладают довольно старым, хоть и востребованным у
      покупателей, жилым фондом. Появление новых проектов-доминант с нетипичной
      для района архитектурой мгновенно изменило к ним отношение. За счет более
      высокой стоимости квадратного метра в проектах бизнес-класса, поднялась
      средняя цена «квадрата» по району в целом, а значит, поменялась строка в
      городском рейтинге престижности, что достаточно значимо в том числе для
      владельцев жилья в окрестных домах.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Проект &laquo;Наследие&raquo; во&nbsp;многом изменил инфраструктурную
      составляющую района, пополнив количество социальных учреждений детским
      садом на&nbsp;220&nbsp;мест&nbsp;&mdash; объект будет построен в&nbsp;2019
      году. На&nbsp;территории комплекса уже открылись новые магазины, кафе-бар,
      кофейня, пиццерия, салоны красоты, отделение банка, салон связи
      и&nbsp;пр.&nbsp;Пользоваться инфраструктурой могут не&nbsp;только
      владельцы квартир, приятнее и&nbsp;удобнее вести быт стало
      и&nbsp;остальным жителям района. Но&nbsp;главное, у&nbsp;коренных
      обитателей района Преображенское появилась возможность повысить класс
      своего жилья, не&nbsp;покидая привычного района с&nbsp;хорошей экологией.
    </Spreader>
    <Spreader isDisappear>
      <Scalable style={{ marginBottom: '1.5%' }}>
        <img width="100%" src={'images/media/grid_t4_1.jpg'} />
      </Scalable>
    </Spreader>
    <Spreader isWide>
      <Sticker>
        <QuoteNoPhoto text="Уникальны и видовые характеристики: стоять у панорамного окна, смотреть, как в стеклянных башнях Сити отражается закат, строить планы… Именно так появляются владельцы крупных бизнесов и главы корпораций." />
      </Sticker>
    </Spreader>
    <Spreader isDisappear style={{ marginBottom: '40px' }}>
      <Grid
        fullWidth={3}
        blocks={[
          {
            width: 2,
            content: (
              <Scalable>
                <img src="images/media/grid_t4_2.jpg" width="100%" />
              </Scalable>
            ),
          },
          {
            width: 1,
            content: (
              <Scalable
                style={{ marginBottom: '5%', marginLeft: '5%', width: '95%' }}
              >
                <img src="images/media/grid_t4_3.jpg" width="100%" />
              </Scalable>
            ),
          },
          {
            width: 1,
            content: (
              <Scalable style={{ marginLeft: '5%' }}>
                <img src="images/media/grid_t4_4.jpg" width="100%" />
              </Scalable>
            ),
          },
        ]}
      />
      <Mention>
        На фото: Квартал{' '}
        <a
          href="https://matchpointhouse.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
          target="_blank"
        >
          «Матч Поинт»
        </a>
      </Mention>
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Проект бизнес-класса &laquo;Наследие&raquo; несет в&nbsp;себе
      не&nbsp;только инфраструктурную пользу, прелесть архитектурной новизны
      и&nbsp;свежесть дорогой отделки общественных зон, но&nbsp;и&nbsp;такие
      опции, как просторный двухуровневый подземный паркинг с&nbsp;увеличенным
      количеством мест&nbsp;&mdash; можно припарковать машину и&nbsp;подняться
      в&nbsp;квартиру, не&nbsp;выходя на&nbsp;улицу. Особая гордость
      проекта&nbsp;&mdash; внутренний двор&nbsp;&mdash; представляет собой собственный
      мини-парк с&nbsp;ландшафтным дизайном и&nbsp;разнообразными возможностями
      для прогулок, тихого и&nbsp;активного отдыха.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Но&nbsp;если &laquo;Наследие&raquo; квартал все&nbsp;же скорее семейный,
      да&nbsp;и&nbsp;район больше ориентирован на&nbsp;спокойную, семейную, даже
      где-то &laquo;загородную&raquo; атмосферу&nbsp;&mdash; все&nbsp;же рядом
      Сокольники и&nbsp;Лосиный остров, то&nbsp;в&nbsp;случае с&nbsp;Match Point
      ситуация еще более интересная.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Проект как раз призван добавить драйва тихой размеренной жизни района
      Филевский парк. Проект интересен в первую очередь динамичной аудиторией,
      на которую он рассчитан. Энергия и динамика видны сразу в всем – и в
      архитектуре, и в инфраструктуре – в рамках проекта строится волейбольная
      арена.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Проект бизнес-класса изменит облик тихой улицы Василисы Кожиной, которая после реконструкции будет четырехполосной, и станет
      местной достопримечательностью и новым районным ориентиром. В рамках
      проекта завершается строительство самой современной в городе волейбольной
      арены, которая тоже внесет свою лепту в повышение престижности района –
      удивительно, но демократичный вид спорта вдруг тоже повысил класс: во
      вновь вошедший в моду волейбол с удовольствием играют менеджеры и
      бизнесмены, отрабатывая навыки командной работы, умение отдавать мяч и
      делать точные передачи. Вместе с волейбольной ареной появятся и
      сопутствующие сервисы: спа-салон, тренажерный зал, банный комплекс, залы
      для занятий групповыми видами спорта.
    </Spreader>

    

    <Spreader style={{ marginBottom: '10px' }}>
      Но главное, в районе появятся новые люди – динамичные, живущие в ритме
      большого города. Именно они – основная целевая аудитория проекта Match
      Point. Выбор определяет концепция проекта: вариативность площадей – от
      28-метровых студий до 185 – метровых квартир с панорамным остеклением на
      последних этажах. Подземный паркинг на 1602 м/м – больше, чем одно место
      на апартамент, которых 1545 – редкая, если не уникальная опция для
      близкого к центру района города. В продажу машино-места еще не выходили,
      но лист ожидания уже достаточно длинный. Ориентировочно стоимость места
      для машины будет 1,7–1,8 млн в зависимости от его размера и местоположения
      на парковке.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Уникальны и видовые характеристики: стоять у панорамного окна, смотреть,
      как в стеклянных башнях Сити отражается закат, строить планы… Именно так
      появляются владельцы крупных бизнесов и главы корпораций.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      Всякий бизнесмен умеет считать деньги – в случае с Match Point это подсчет
      со знаком плюс. Стоимость минимального лота начинается от 6,8
      млн руб. До 28 декабря действует скидка в 19%.
    </Spreader>

    <Spreader isDisappear style={{ marginBottom: '40px' }}>
      <Scalable>
        <Banner
          text="За детальной информацией переходите на сайт  hals&#8209;development.ru"
          linkTitle="Перейти на сайт сейчас"
          link="https://hals-development.ru/?utm_source=kommersant&utm_medium=Cpec_project&utm_campaign=hals"
          bannerBackground="images/banner-bg.png"
        />
      </Scalable>
    </Spreader>

    <Spreader style={{ marginBottom: '10px' }}>
      Еще приятнее говорить о стоимости метра: в среднем она составляет 230– 240
      тыс. руб. за 1 кв. м. Ближайшие конкуренты гораздо дороже. Приятно
      говорить и о финансовых условиях покупки: при приобретении апартамента в
      ипотеку первоначальный взнос составляет всего 10%. При рассрочке — 30%.
      Проект работает с разными банками. Одна из самых выгодных ставок,
      разумеется, у финансового партнера — банка ВТБ: 6,1% годовых.
    </Spreader>

    <Spreader style={{ marginBottom: '10px' }}>
      Заняться бизнесом можно и не выходя за пределы дома: скоро в продажу
      выйдут коммерческие помещения на первых этажах. В каждой из двух
      симметричных половин комплекса на первых этажах запанировано по шесть-семь
      стометровых помещений с высотой потолка 5 м. Таким образом, на первых
      этажах появится общедоступная инфраструктура: новые модные кафе с
      панорамными окнами, магазины фермерских продуктов, салоны красоты – все,
      чего не хватало району для статуса.
    </Spreader>
    <Spreader style={{ marginBottom: '10px' }}>
      И, конечно, решающую точку в изменении статуса района играет архитектурное
      решение: в ближайшее время откроются фасады Math Point – дорогие и
      современные. Здание станет приковывать взгляды, добавит улице, району, да
      и всему округу современности и откровенно намекнет на перспективу
      дальнейшего развития.
    </Spreader>
  </StickyContainer>
);

export default PlacePage;
//<CallToAction />
